var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading-page"},[_c('van-loading',{attrs:{"size":"34px","color":"#1989fa","vertical":""}},[_vm._v(_vm._s(_vm.loadTxt || '加载中...'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }